const OfferActionTypes = {
  GET_COUPON_LIST_REQUEST: "GET_COUPON_LIST_REQUEST",
  GET_COUPON_LIST_SUCCESS: "GET_COUPON_LIST_SUCCESS",
  GET_COUPON_LIST_FAILED: "GET_COUPON_LIST_FAILED",
};

export default OfferActionTypes;
